// extracted by mini-css-extract-plugin
export var noScroll = "fadeInOnFontLoad-module--no-scroll--bf18d";
export var overlay = "fadeInOnFontLoad-module--overlay--94724";